export default __webpack_public_path__ + "static/allProjects1-10558800016a532e87d0fc3c48d75f9e.png";